import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  DIRECT_MESSAGE_LIST,
  ORDER_COMMENT_LIST,
} from "../../constants/routes";

export type MessageTabType = "Direct messages" | "Order comments" | undefined;

export const useMessageTabSelect = (): [
  MessageTabType,
  (tab: "Order comments" | "Direct messages") => void,
] => {
  const navigate = useNavigate();
  const location = useLocation();

  // get current tab from the url path, this is the source of truth
  const currentTab = useMemo(() => {
    if (location.pathname.includes("direct-messages")) {
      return "Direct messages";
    }

    if (location.pathname.includes("order-comments")) {
      return "Order comments";
    }

    return undefined;
  }, [location.pathname]);

  return [
    currentTab,
    (tab: "Order comments" | "Direct messages") => {
      if (tab === "Order comments") {
        return navigate(ORDER_COMMENT_LIST);
      }

      if (tab === "Direct messages") {
        return navigate(DIRECT_MESSAGE_LIST);
      }
    },
  ];
};
